<template>
  <v-toolbar>
    <v-toolbar-side-icon style="width: 150px">
      <a :href="linkHome()">
        <img src="../assets/nbm_logo_200.gif" style="height: 50px" />
      </a>
    </v-toolbar-side-icon>
    <v-toolbar-title>Solicitors</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat :to="{ name: 'fees' }">Conveyancing fees</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: "Navbar",
  methods: {
    linkHome() {
      return process.env.VUE_APP_NB_URL;
    }
  }
};
</script>

<style></style>